import actionsIcon from "../../../assets/images/actionsCircle.svg";
import CustomPagination from "../../../components/pagination/CustomPagination";
import CompanyActionModal from "../../../components/modal/companyActionModal";
import { useEffect, useRef, useState } from "react";
import SuccessMessage from "../../../components/modal/SuccessMessage";
import sortArrow from "../../../assets/images/sortArrow.svg";
import moment from "moment";
import * as companyActions from "../../../redux/companies/companiesAction";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { useNavigate } from "react-router-dom";
import { refactorUserManagement } from "../../../helper/helperFunctions";
import * as autActions from "../../../redux/auth/authAction";
import Skeleton from "react-loading-skeleton";
import toast from "react-hot-toast";
import { scheduleStagingTestAction } from "../../../redux/companies/companiesCrud";
import { getStagingTestActionAvailability, StagingTestActionType, useStagingTestActionsEnabled } from "../../../helper/useStagingTestActions";
// import { useNavigate } from "react-router-dom";

interface TableIProps {
  tableHeaderState: any;
  companiesList: any;
  handleSelectTableCheckbox: any;
  handleSelectAllTableCheckbox: any;
  filterCount?: number;
  size?: number;
  total?: number;
  setSize?: any;
  setPage?: any;
  page?: number;
  setTotal?: any;
  deltedCompany?: boolean;
  handleSort?: any;
  setisCompanySuspended?: any;
  companySuspend?: any;
  setCompanyLoading?: any;
  countryList?: any;
  planList?: any;
  seatsList?: any;
  statusList?: any;
  daysList?: any;
  deleteCompanyLoading?: boolean;
  setDeleteCompanyLoading?: any;
  sortField?: string;
  sortBy?: any;
  setSortField?: any;
  setSortBy?: any;
  handleArrowSortClick?: any;
  searchValue: string;
  getSelectedFilters: () => any;
  selectedHeader?: any;
  setcountryLoading?: any;
  loading?: boolean;
}

function Table({
  tableHeaderState,
  companiesList,
  handleSelectTableCheckbox,
  handleSelectAllTableCheckbox,
  setPage,
  setSize,
  page,
  size,
  total,
  setTotal,
  filterCount,
  deltedCompany,
  handleSort,
  companySuspend,
  setCompanyLoading,
  countryList,
  seatsList,
  statusList,
  planList,
  daysList,
  deleteCompanyLoading,
  setDeleteCompanyLoading,
  sortField,
  sortBy,
  setSortBy,
  setSortField,
  handleArrowSortClick,
  searchValue,
  setcountryLoading,
  getSelectedFilters,
  selectedHeader,
  loading,
}: TableIProps) {
  const [groupActionOpen, setgroupActionOpen] = useState({ value: false, id: null });
  const [suspendModaOpen, setSuspendModaOpen] = useState({ value: false, id: 0 });
  const [emailModalOpen, setEmailModalOpen] = useState({ value: false, id: 0 });
  const [deleteModaOpen, setdeleteModaOpen] = useState({ value: false, id: 0 });
  const [restoreModalOpen, setRestoreModalOpen] = useState({ value: false, id: 0 });
  const [showSuccessEmail, setShowSuccessEmail] = useState({ value: false, id: 0 });
  const [showSuccessSuspend, setShowSuccessSuspend] = useState({ value: false, id: 0 });
  const [showSuccessDeletion, setshowSuccessDeletion] = useState({ value: false, id: 0 });
  const [showSuccessRestoration, setShowSuccessRestoration] = useState({ value: false, id: 0 });
  const [showSuccessResume, setShowSuccessResume] = useState({ value: false, id: 0 });
  const [endBillingCycleModalOpen, setEndBillingCycleModalOpen] = useState({ value: false, id: 0 });
  const [endTrialModalOpen, setEndTrialModalOpen] = useState({ value: false, id: 0 });
  const [showSuccessStagingAction, setShowSuccessStagingAction] = useState({ value: false, id: 0, message: "" });
  const [stagingActionLoading, setStagingActionLoading] = useState(false);
  const stagingTestActionsEnabled = useStagingTestActionsEnabled();
  const [reason, setReason] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMessage, setEmailMessage] = useState<string>("");
  const [userLoading, setuserLoading] = useState(false);
  // eslint-disable-next-line
  const [selectedId, setselectedId] = useState(0);
  const openGroupActionModalRef = useRef<any>();
  const [showResumeOption, setshowResumeOption] = useState({ value: false, id: 0 });
  // eslint-disable-next-line
  const [isCompanySuspended, setisCompanySuspended] = useState({ value: false, id: 0 });
  const [deleteTextColor, setDeleteTextColor] = useState({ value: true, color: "#EB5757", id: 0 });

  // const navigate = useNavigate();
  const handleModalOpen = (id: number) => {
    let finded = companiesList.length > 0 && companiesList.find((item: any) => item.id === id);
    if (finded.isSuspended) {
      setgroupActionOpen({ ...groupActionOpen, id: finded.id, value: true });
      setselectedId(finded.id);
      setisCompanySuspended({ value: true, id: finded.id });
    } else {
      setgroupActionOpen({ ...groupActionOpen, id: finded.id, value: true });
      setselectedId(finded.id);
      setisCompanySuspended({ value: false, id: 0 });
    }
    if (
      finded?.subscription?.currentPlan?.status === "Free" ||
      finded?.subscription?.currentPlan?.status === "Paused" ||
      (finded?.subscription?.currentPlan?.plan === "Free" && finded?.subscription?.currentPlan?.status === "Running") ||
      finded?.subscription?.userTrial?.isTrialCancelled ||
      finded?.subscription?.currentPlan?.status === "Expired"
    ) {
      if (deleteTextColor.id === selectedId) {
        setDeleteTextColor({ ...deleteTextColor, color: "#EB5757" });
      } else {
        setDeleteTextColor({ ...deleteTextColor, color: "#828282" });
      }
    } else {
      setDeleteTextColor({ ...deleteTextColor, color: "#828282" });
    }
  };

  useEffect(() => {
    if (selectedId !== 0) {
      setDeleteTextColor({ ...deleteTextColor, id: selectedId });
    }
    // eslint-disable-next-line
  }, [groupActionOpen.value]);

  const handleClickOutside = (event: any) => {
    if (openGroupActionModalRef.current && !openGroupActionModalRef.current.contains(event.target)) {
      setgroupActionOpen({ ...groupActionOpen, id: null, value: false });
      setdeleteModaOpen({ ...deleteModaOpen, value: false, id: 0 });
      setshowSuccessDeletion({ ...showSuccessDeletion, value: false, id: 0 });
      setEmailModalOpen({ ...emailModalOpen, value: false, id: 0 });
      setRestoreModalOpen({ ...restoreModalOpen, value: false, id: 0 });
      setshowResumeOption({ ...showResumeOption, value: false, id: 0 });
      setShowSuccessEmail({ ...showSuccessEmail, value: false, id: 0 });
      setSuspendModaOpen({ ...suspendModaOpen, value: false, id: 0 });
      setShowSuccessSuspend({ ...showSuccessSuspend, id: 0, value: false });
      setShowSuccessRestoration({ ...showSuccessRestoration, id: 0, value: false });
      setShowSuccessResume({ ...showSuccessResume, id: 0, value: false });
      setEndBillingCycleModalOpen({ value: false, id: 0 });
      setEndTrialModalOpen({ value: false, id: 0 });
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, []);

  // deleted handler
  const deleteSingleCompany = () => {
    let selectedCompanyIdsForDeletion = companiesList?.filter((item: any) => item.id === selectedId).map((item: any) => item.id);
    dispatch(companyActions.deleteSelectedCompanies(selectedCompanyIdsForDeletion)).then(() => {
      let filters = getSelectedFilters();
      dispatch(
        companyActions.getAllCompanies({
          page: filters.pageNo,
          size: filters.limit,
          countries: filters.countries,
          lastActivityEndDate: filters.lastActivityEndDate,
          lastActivityStartDate: filters.lastActivityStartDate,
          maxUsers: filters.usersTo,
          minUsers: filters.usersFrom,
          planList: filters.plans,
          registerEndDate: filters.registerEndDate,
          registerStartDate: filters.registerStartDate,
          searchName: filters.searchName,
          sortAt: filters.sortAt,
          sortBy: filters.sortBy,
          subscriptionPlanLength: filters?.subscriptionPlanLength,
          // isSuspended: undefined,
        }),
      ).then(() => {
        dispatch(companyActions.getAllCountries("")).then(() => {
          setcountryLoading(true);
        });
      });
    });
    setdeleteModaOpen({ ...deleteModaOpen, id: 0, value: false });
    setgroupActionOpen({ ...groupActionOpen, value: false, id: null });
    setshowSuccessDeletion({ ...showSuccessDeletion, value: true, id: deleteModaOpen.id });
  };

  //suspend handler
  const suspendSingleCompany = () => {
    setSuspendModaOpen({ ...suspendModaOpen, id: 0, value: false });
    let selectedCompanyIdsForSuspension = companiesList?.filter((item: any) => item.id === selectedId).map((item: any) => item.id);
    dispatch(companyActions.suspendSelectedCompanies(selectedCompanyIdsForSuspension, "", true)).then(() => {
      let filters = getSelectedFilters();
      dispatch(
        companyActions.getAllCompanies({
          page: filters.pageNo,
          size: filters.limit,
          countries: filters.countries,
          lastActivityEndDate: filters.lastActivityEndDate,
          lastActivityStartDate: filters.lastActivityStartDate,
          maxUsers: filters.usersTo,
          minUsers: filters.usersFrom,
          planList: filters.plans,
          registerEndDate: filters.registerEndDate,
          registerStartDate: filters.registerStartDate,
          searchName: filters.searchName,
          sortAt: filters.sortAt,
          sortBy: filters.sortBy,
          subscriptionPlanLength: filters?.subscriptionPlanLength,
          // isSuspended: undefined,
        }),
      );
    });
    setgroupActionOpen({ ...groupActionOpen, value: false, id: null });
    setShowSuccessSuspend({ ...showSuccessSuspend, value: true, id: suspendModaOpen.id });
  };

  //email handler
  const sendEmailToSinglCompany = () => {
    let selectedCompaniesToSendEmail = companiesList?.filter((item: any) => item.id === selectedId).map((item: any) => item.email || item.emai);
    if (selectedCompaniesToSendEmail?.length > 0) {
      dispatch(companyActions.sendEmailToCompany(selectedCompaniesToSendEmail, { message: emailMessage, subject: emailSubject })).then(() => {
        setEmailSubject("");
        setEmailMessage("");
      });
    }

    setEmailModalOpen({ ...emailModalOpen, id: 0, value: false });
    setgroupActionOpen({ ...groupActionOpen, value: false, id: null });
    setShowSuccessEmail({ ...emailModalOpen, value: true, id: emailModalOpen.id });
  };

  //restore handler
  const restoreSingleCompany = () => {
    const selectedIdsForRestoration = companiesList?.filter((item: any) => item.id === selectedId).map((item: any) => item.id);
    dispatch(companyActions.restoreDeletedCompanies(selectedIdsForRestoration)).then(() => {
      dispatch(autActions.whoAmI()).then(() => {
        setuserLoading(true);
      });
    });
    setRestoreModalOpen({ ...restoreModalOpen, value: false, id: 0 });
    setgroupActionOpen({ ...groupActionOpen, value: false, id: null });
    setShowSuccessRestoration({ ...showSuccessRestoration, value: true, id: restoreModalOpen.id });
  };

  useEffect(() => {
    if (userLoading) {
      let selectedFilters = getSelectedFilters();
      dispatch(
        companyActions.getAllDeletedCompanies({
          page: selectedFilters.deletedPage,
          size: selectedFilters.deletedSize,
          countries: selectedFilters.countries ? selectedFilters.countries : undefined,
          dayMin: selectedFilters.daysMin,
          daysMax: selectedFilters.daysMax,
          searchName: selectedFilters.searchValue,
          sortAt: selectedFilters.sortAt,
          sortBy: selectedFilters.sortBy,
        }),
      ).then(() => {
        setuserLoading(false);
        dispatch(companyActions.getAllDeletedCountries(""));
      });
    }
    //eslint-disable-next-line
  }, [userLoading]);

  //resume handler
  const resumeSingleCompany = () => {
    setshowResumeOption({ ...showResumeOption, value: false, id: 0 });
    setgroupActionOpen({ ...groupActionOpen, value: false, id: null });
    setCompanyLoading(true);
    let selectedCompanyIdsForSuspension = companiesList?.filter((item: any) => item.id === selectedId).map((item: any) => item.id);
    dispatch(companyActions.suspendSelectedCompanies(selectedCompanyIdsForSuspension, "", false)).then(() => {
      let filters = getSelectedFilters();
      dispatch(
        companyActions.getAllCompanies({
          page: filters.pageNo,
          size: filters.limit,
          countries: filters.countries,
          lastActivityEndDate: filters.lastActivityEndDate,
          lastActivityStartDate: filters.lastActivityStartDate,
          maxUsers: filters.usersTo,
          minUsers: filters.usersFrom,
          planList: filters.plans,
          registerEndDate: filters.registerEndDate,
          registerStartDate: filters.registerStartDate,
          searchName: filters.searchName,
          sortAt: filters.sortAt,
          sortBy: filters.sortBy,
          subscriptionPlanLength: filters?.subscriptionPlanLength,
          // isSuspended: undefined,
        }),
      );
    });
    setShowSuccessResume({ ...showSuccessResume, value: true, id: showResumeOption.id });
    setReason("");
  };

  const dispatch: AppDispatch | any = useDispatch();

  //staging test action handlers - only reachable when the backend reports the feature flag on
  const closeStagingActionModals = () => {
    setEndBillingCycleModalOpen({ value: false, id: 0 });
    setEndTrialModalOpen({ value: false, id: 0 });
  };
  const openEndBillingCycleModalHandler = () => {
    closeStagingActionModals();
    setEndBillingCycleModalOpen({ value: true, id: selectedId });
  };
  const openEndTrialModalHandler = () => {
    closeStagingActionModals();
    setEndTrialModalOpen({ value: true, id: selectedId });
  };
  const scheduleStagingAction = (type: StagingTestActionType) => {
    if (stagingActionLoading) return;
    const companyId = selectedId;
    setStagingActionLoading(true);
    scheduleStagingTestAction(String(companyId), type)
      .then(() => {
        setShowSuccessStagingAction({
          value: true,
          id: companyId,
          message: type === "trial" ? "Trial termination scheduled successfully" : "Billing cycle now ends in 1 minute",
        });
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message || "The termination could not be scheduled");
      })
      .finally(() => {
        setStagingActionLoading(false);
        closeStagingActionModals();
        setgroupActionOpen({ value: false, id: null });
      });
  };

  const handleConfirmation = () => {
    if (deleteModaOpen.value === true) {
      deleteSingleCompany();
    } else if (suspendModaOpen.value === true && showResumeOption.value === false) {
      suspendSingleCompany();
    } else if (emailModalOpen.value === true) {
      sendEmailToSinglCompany();
    } else if (restoreModalOpen.value === true) {
      restoreSingleCompany();
    } else if (showResumeOption.value === true) {
      resumeSingleCompany();
    }
  };

  const handleCancel = () => {
    if (deleteModaOpen.value) setdeleteModaOpen({ ...deleteModaOpen, value: false, id: 0 });
    else if (suspendModaOpen.value) setSuspendModaOpen({ ...suspendModaOpen, value: false, id: 0 });
    else if (emailModalOpen.value) setEmailModalOpen({ ...emailModalOpen, value: false, id: 0 });
    else if (restoreModalOpen.value) setRestoreModalOpen({ ...restoreModalOpen, value: false, id: 0 });
    else if (showResumeOption.value) setshowResumeOption({ ...showResumeOption, value: false, id: 0 });
  };
  //open deleteModal
  const openDeleteModalHandler = () => {
    setdeleteModaOpen({ ...deleteModaOpen, id: selectedId, value: true });
  };
  const openSuspendModalHandler = () => {
    if (!isCompanySuspended.value) {
      setSuspendModaOpen({ ...suspendModaOpen, id: selectedId, value: true });
    }
  };
  const openEmailModalHandler = () => {
    setEmailModalOpen({ ...emailModalOpen, id: selectedId, value: true });
  };
  const openRestoreModalHandler = () => {
    setRestoreModalOpen({ ...restoreModalOpen, id: selectedId, value: true });
  };
  const openResumeHandler = () => {
    if (isCompanySuspended.value === true) {
      setshowResumeOption({ ...showResumeOption, id: selectedId, value: true });
    }
  };
  //closing success modal
  const handleSuccessConfirmation = () => {
    if (showSuccessDeletion.value) {
      setshowSuccessDeletion({ ...showSuccessDeletion, value: false, id: 0 });
    } else if (showSuccessEmail.value) {
      setShowSuccessEmail({ ...showSuccessEmail, value: false, id: 0 });
    } else if (showSuccessSuspend.value) {
      setShowSuccessSuspend({ ...showSuccessSuspend, value: false, id: 0 });
    } else if (showSuccessRestoration.value) {
      setShowSuccessRestoration({ ...showSuccessRestoration, value: false, id: 0 });
    } else if (showSuccessResume.value) {
      setShowSuccessResume({ ...showSuccessResume, value: false, id: 0 });
    }
  };
  const handleReason = (e: any) => {
    setReason(e.target.value);
  };
  // eslint-disable-next-line
  const navigate = useNavigate();
  return (
    <div>
      <div className="table-responsive w-100">
        <table className="table table-main  ">
          {tableHeaderState?.filter((item: any) => item.isSelected)?.length > 0 ? (
            <thead>
              <tr>
                {!deltedCompany ? (
                  <th style={{ border: "none" }}>
                    <input
                      type="checkbox"
                      className="checkbox"
                      style={{
                        height: "16px",
                        width: "16px",
                        border: "none",
                        background: "#F2F2F2",
                      }}
                      checked={
                        companiesList && companiesList?.length > 0
                          ? companiesList?.filter((item: any) => !item.isSelected)?.length > 0
                            ? false
                            : true
                          : false
                      }
                      onClick={() => {
                        handleSelectAllTableCheckbox();
                      }}
                    />
                  </th>
                ) : null}

                {tableHeaderState.map((item: any, index: number) => {
                  let finded = item.isSelected;

                  return (
                    <th
                      key={index}
                      scope="col"
                      data-align="start"
                      className="header text-start"
                      style={{
                        color: "#4F4F4F",
                        columnFill: "balance",
                        border: "none",
                        fontWeight: 700,
                        fontSize: "14px",
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleSort(item);
                          }}
                        >
                          {finded ? item.label.toUpperCase() : ""}
                        </div>

                        {finded && item.value.includes(selectedHeader.value) ? (
                          <img
                            id="sort-icon"
                            onClick={handleArrowSortClick}
                            src={sortArrow}
                            alt="sort-icon"
                            className="ml-2"
                            style={{ verticalAlign: "initial", cursor: "pointer", zIndex: "99" }}
                          />
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
          ) : null}
          {loading ? (
            <tbody className="w-100">
              <tr className="w-100">
                <td colSpan={tableHeaderState?.length+1}>
                  <Skeleton width={"100%"} height={40}/>
                </td>{" "}
              </tr>
            </tbody>
          ) : (
            <tbody
              className="w-100 h-100"
              style={{
                color: "#333333",
                fontWeight: "400",
                fontSize: "12px",
                flexWrap: "wrap",
              }}
            >
              {tableHeaderState?.filter((item: any) => item.isSelected)?.length > 0 && companiesList?.length > 0
                  ? companiesList.map((item: any, index: number) => {
                    return (
                      <tr
                        key={index}
                        style={{
                          height: index === companiesList.length - 1 ? "" : "50px",
                          color: "#333333",
                          fontWeight: "400",
                          fontSize: "12px",
                          border: "1px solid #EAEAEA",
                          borderLeft: "none",
                          borderRight: "none",
                          textAlign: "center",
                        }}
                      >
                        {!deltedCompany ? (
                          <th
                            scope="row"
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                              alignItems: "start",
                              display: "flex",
                              justifyContent: "start",
                              border: "none",
                            }}
                          >
                            <input
                              type="checkbox"
                              className="checkbox"
                              style={{ height: "16px", width: "16px", border: "none", background: "#F2F2F2" }}
                              checked={item.isSelected}
                              onClick={() => {
                                handleSelectTableCheckbox(item.id);
                              }}
                            />
                          </th>
                        ) : null}

                        <td
                          style={{
                            color: "#333333",
                            fontWeight: "400",
                            fontSize: "14px",
                          }}
                          onClick={() => navigate(`/company/${item.id}`)}
                        >
                          {tableHeaderState?.filter((item: any) => item.id === "1" && item.isSelected)?.length > 0 ? item?.businessId : ""}
                        </td>
                        <td
                          style={{
                            color: "#333333",
                            fontWeight: "400",
                            fontSize: "14px",
                          }}
                          onClick={() => navigate(`/company/${item.id}`)}
                        >
                          {tableHeaderState?.filter((item: any) => item.id === "2" && item.isSelected)?.length > 0 ? item?.businessName : ""}
                        </td>

                        {!deltedCompany ? (
                          <td
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                            }}
                            onClick={() => navigate(`/company/${item.id}`)}
                          >
                            {tableHeaderState?.filter((item: any) => item.id === "3" && item.isSelected)?.length > 0 ? item.email : ""}
                          </td>
                        ) : (
                          <td
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                            }}
                            onClick={() => navigate(`/company/${item.id}`)}
                          >
                            {tableHeaderState?.filter((item: any) => item.id === "3" && item.isSelected)?.length > 0
                              ? `${item.ownerName?.first} ${item.ownerName?.last}`
                              : ""}
                          </td>
                        )}
                        {!deltedCompany ? (
                          <td
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                            }}
                            onClick={() => navigate(`/company/${item.id}`)}
                          >
                            {tableHeaderState?.filter((item: any) => item.id === "4" && item.isSelected)?.length > 0 ? item?.country : ""}
                          </td>
                        ) : (
                          <td
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                            }}
                            onClick={() => navigate(`/company/${item.id}`)}
                          >
                            {tableHeaderState?.filter((item: any) => item.id === "4" && item.isSelected)?.length > 0 ? item?.emai : ""}
                          </td>
                        )}

                        {!deltedCompany && (
                          <>
                            {" "}
                            <td
                              style={{
                                color: "#333333",
                                fontWeight: "400",
                                fontSize: "14px",
                              }}
                              onClick={() => navigate(`/company/${item.id}`)}
                            >
                              {tableHeaderState?.filter((item: any) => item.id === "5" && item.isSelected)?.length > 0
                                ? refactorUserManagement(
                                    item?.subscription?.currentPlan?.plan,
                                    item?.subscription?.currentPlan?.status,
                                    item.isSuspended,
                                    item?.subscription?.userTrial?.isTrialCancelled,
                                    item?.subscription?.userTrial?.isTrialStarted,
                                    item?.subscription?.userTrial?.isTrialExpired,
                                  )
                                : ""}
                            </td>
                            <td
                              style={{
                                color: "#333333",
                                fontWeight: "400",
                                fontSize: "14px",
                              }}
                              onClick={() => navigate(`/company/${item.id}`)}
                            >
                              {tableHeaderState?.filter((item: any) => item.id === "6" && item.isSelected)?.length > 0
                                ? moment(item?.created_at).format("DD/MM/yyyy")
                                : ""}
                            </td>
                            <td
                              style={{
                                color: "#333333",
                                fontWeight: "400",
                                fontSize: "14px",
                              }}
                              onClick={() => navigate(`/company/${item.id}`)}
                            >
                              {tableHeaderState?.filter((item: any) => item.id === "7" && item.isSelected)?.length > 0
                                ? moment(item?.updated_at).format("DD/MM/yyyy hh:mm")
                                : ""}
                            </td>
                          </>
                        )}
                        {deltedCompany && (
                          <td
                            style={{
                              color: "#333333",
                              fontWeight: "400",
                              fontSize: "14px",
                            }}
                            onClick={() => navigate(`/company/${item._id}`)}
                          >
                            {tableHeaderState?.filter((item: any) => item.id === "5" && item.isSelected)?.length > 0 ? item?.country : ""}
                          </td>
                        )}

                        {!tableHeaderState.find((item: any) => item.value === "daysLeft") ? (
                          <>
                            <td
                              style={{
                                color: "#333333",
                                fontWeight: "400",
                                fontSize: "14px",
                              }}
                            >
                              {tableHeaderState?.filter((item: any) => item.id === "8" && item.isSelected)?.length > 0 ? item?.usersCount : ""}
                            </td>
                          </>
                        ) : (
                          <td> {tableHeaderState?.filter((item: any) => item.id === "6" && item.isSelected).length > 0 ? item.daysLeft : ""}</td>
                        )}

                        <td
                          style={{
                            // color: ReportStatusColorHandler(item?.status),
                            fontWeight: "400",
                            fontSize: "14px",
                          }}
                        >
                          <div style={{ position: "relative" }}>
                            <span
                              onClick={() => {
                                handleModalOpen(item.id);
                              }}
                            >
                              <img src={actionsIcon} alt="actionsIcon" />
                              <img src={actionsIcon} alt="actionsIcon" />
                              <img src={actionsIcon} alt="actionsIcon" />
                            </span>

                            {groupActionOpen.value && groupActionOpen.id === item.id ? (
                              <div style={{ position: "absolute", top: 0, right: 0, width: "333px", height: "133px" }} ref={openGroupActionModalRef}>
                                <CompanyActionModal
                                  suspendModalOpen={suspendModaOpen.value}
                                  emailModalOpen={emailModalOpen.value}
                                  deleteModaOpen={deleteModaOpen.value}
                                  restoreModalOpen={restoreModalOpen.value}
                                  openEmailModalHandler={openEmailModalHandler}
                                  openSuspendModalHandler={openSuspendModalHandler}
                                  openRestoreModalHandler={openRestoreModalHandler}
                                  tableView={true}
                                  reason={reason}
                                  handleReason={handleReason}
                                  setEmailMessage={setEmailMessage}
                                  setEmailSubject={setEmailSubject}
                                  emailSubject={emailSubject}
                                  emailMessage={emailMessage}
                                  message=""
                                  handleSuccessConfirmation={handleSuccessConfirmation}
                                  // setMessage={}
                                  // setReason={}
                                  onConfirmation={handleConfirmation}
                                  openDeleteModalHandler={openDeleteModalHandler}
                                  onCancel={handleCancel}
                                  deletedCompanyView={deltedCompany}
                                  showResumeOption={showResumeOption.value}
                                  openResumeHandler={openResumeHandler}
                                  isCompanySuspended={isCompanySuspended.value}
                                  textDeleteColor={deleteTextColor.color}
                                  showEndBillingCycleOption={
                                    stagingTestActionsEnabled && getStagingTestActionAvailability(item?.subscription, item.isSuspended).billingCycle
                                  }
                                  showEndTrialOption={stagingTestActionsEnabled && getStagingTestActionAvailability(item?.subscription, item.isSuspended).trial}
                                  endBillingCycleModalOpen={endBillingCycleModalOpen.value}
                                  endTrialModalOpen={endTrialModalOpen.value}
                                  openEndBillingCycleModalHandler={openEndBillingCycleModalHandler}
                                  openEndTrialModalHandler={openEndTrialModalHandler}
                                  onEndBillingCycleConfirmation={() => scheduleStagingAction("billingCycle")}
                                  onEndTrialConfirmation={() => scheduleStagingAction("trial")}
                                  onStagingActionCancel={closeStagingActionModals}
                                  stagingActionLoading={stagingActionLoading}
                                />
                              </div>
                            ) : null}
                            <div style={{ zIndex: 1001, position: "absolute", right: "56px", bottom: "12px", width: "317px", background: "#FFFFFF" }}>
                              {showSuccessDeletion.value && showSuccessDeletion.id === item.id ? (
                                <SuccessMessage setshowSuccessCompletion={setshowSuccessDeletion} message="Company  deleted successfully " />
                              ) : (
                                ""
                              )}
                              {showSuccessSuspend.value && showSuccessSuspend.id === item.id ? (
                                <SuccessMessage setshowSuccessCompletion={setShowSuccessSuspend} message="Company  suspended successfully " />
                              ) : null}
                              {showSuccessEmail.value && showSuccessEmail.id === item.id ? (
                                <SuccessMessage setshowSuccessCompletion={setShowSuccessEmail} message="The email was successfully sent" />
                              ) : null}
                              {/* {showSuccessRestoration.value && showSuccessRestoration.id === item.id ? (
                              <SuccessMessage setshowSuccessCompletion={setShowSuccessRestoration} message="Company restored successfully" />
                            ) : null} */}
                              {showSuccessResume.value && showSuccessResume.id === item.id ? (
                                <SuccessMessage setshowSuccessCompletion={setShowSuccessResume} message="Company resumed successfully" />
                              ) : null}
                              {showSuccessStagingAction.value && showSuccessStagingAction.id === item.id ? (
                                <SuccessMessage setshowSuccessCompletion={setShowSuccessStagingAction} message={showSuccessStagingAction.message} />
                              ) : null}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          )}
        </table>
      </div>
      <CustomPagination page={page!} setSize={setSize} setpage={setPage} size={size!} total={total!} filterCount={filterCount} />
    </div>
  );
}

export default Table;
